import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import MenuItem from './MenuItem';
var getMenuItems = function getMenuItems(items, closeMenu, onMouseEnter) {
  return items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(MenuItem, _extends({
      key: index
    }, item, {
      index: index,
      closeMenu: closeMenu,
      onMouseEnter: onMouseEnter
    }));
  });
};
export default getMenuItems;